import { Department } from "@/utils/department";

export class AdminDepartment {
	id:number;
	adminId:number;
	departmentId:Department;

	constructor(data:any) {
		this.id = data.id;
		this.adminId = data.adminId;
		this.departmentId = data.departmentId;
	}
}